import { Nullable } from "src/js/types/Nullable";
import SITE_OVERVIEW from "react-migration/domains/sites/apollo/li-api/queries/siteOverview.gql";
import { SiteOverview } from "../typings/Site";
import { routedClient } from "react-migration/lib/persistence/apollo";
import { useQuery } from "@apollo/client";

interface SiteOverviewResponse {
  siteOverview: SiteOverview;
}

interface GetSiteByIdOptions {
  isShared?: boolean;
  includeSiteSummary?: boolean;
  useCache?: boolean;
}

export async function getSiteById(_id: string, options?: GetSiteByIdOptions): Promise<Nullable<SiteOverview>> {
  const { isShared = false, includeSiteSummary = false, useCache = true } = options ?? {};

  try {
    const response = await routedClient.query<SiteOverviewResponse>({
      query: SITE_OVERVIEW,
      variables: { _id, isShared, includeSiteSummary },
      fetchPolicy: useCache ? "cache-first" : "network-only",
    });

    return response.data?.siteOverview || null;
  } catch (e) {
    return null;
  }
}

export function useSiteById(
  siteId?: string | null,
  options?: GetSiteByIdOptions
): {
  site: SiteOverview | undefined;
  loading: boolean;
} {
  const { isShared = false, includeSiteSummary = false } = options ?? {};

  const { data, ...rest } = useQuery<SiteOverviewResponse>(SITE_OVERVIEW, {
    variables: { _id: siteId, isShared, includeSiteSummary },
    client: routedClient,
    skip: !siteId,
  });

  return { site: data?.siteOverview, ...rest };
}
